import React from 'react';
import { Helmet } from 'react-helmet';
import BrandHeader from './components/BrandHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import Icon from '../../components/AppIcon';



const AdminLogin = () => {
  const verificationMessage = null; // or use useState if this should be stateful
  
  return (
    <>
      <Helmet>
        <title>Admin Login - Radiavision Studio Gallery</title>
        <meta name="description" content="Sign in to Radiavision Studio's admin portal. Access for owners and contributors only." />
      </Helmet>
      <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--color-background)' }}>
        <div className="flex-1 flex items-center justify-center px-4 py-12">
          <div className="w-full max-w-md">
            {/* Verification Success Message */}
            {verificationMessage && (
              <div className="mb-6 bg-success/10 border border-success/20 rounded-lg p-4 flex items-start gap-3">
                <Icon name="CheckCircle" size={20} className="text-success mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-success">{verificationMessage}</p>
                </div>
              </div>
            )}

            {/* Card */}
            <div className="bg-card border border-border rounded-2xl shadow-warm-lg p-8">
              <BrandHeader />
              
              <div
                className="p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl shadow-warm-lg"
                style={{ backgroundColor: 'var(--color-card)' }}>

                <LoginForm />
              </div>
              
              <SecurityBadges />
            </div>
          </div>
        </div>

        <footer className="py-4 md:py-6 text-center border-t" style={{
          borderColor: 'var(--color-border)',
          backgroundColor: 'var(--color-card)'
        }}>
          <p className="text-xs md:text-sm caption" style={{ color: 'var(--color-muted-foreground)' }}>
            &copy; {new Date()?.getFullYear()} Radiavision Studio. All rights reserved.
          </p>
        </footer>
      </div>
    </>
  );
};

export default AdminLogin;